import { useQuery } from '@tanstack/react-query';
import { getCurriculumCharacters } from '../api/characters';

// Returns every character in the learner's curriculum (ordered by position),
// with any existing learning state attached. Unintroduced characters carry
// state: null so the UI can render them with no badge. This is distinct from
// useChildCharacters, which only returns introduced characters and is used
// by PracticePage and WorkbookPage where unintroduced chars must not appear.
export function useCurriculumCharacters(learnerId) {
  return useQuery({
    queryKey: ['curriculumCharacters', learnerId],
    queryFn: () => getCurriculumCharacters(learnerId),
    enabled: !!learnerId,
    select: (data) => {
      const rawList = Array.isArray(data) ? data : data.characters || [];
      return rawList.map((row) => {
        const c = row.characters || {};
        return {
          id: c.id,
          char: c.simplified_char,
          pinyin: c.pinyin,
          meaning: c.definition_en,
          radical: c.radical,
          stroke_count: c.stroke_count,
          hsk_level: c.hsk_level,
          state: row.state || null,
          stateRowId: row.id || null,
          auto_graduated_session_count: row.auto_graduated_session_count ?? null,
          worksheets_completed: row.worksheets_completed ?? null,
          character_id: c.id,
        };
      });
    },
  });
}
